module.exports = __webpack_public_path__ + "img/sumary_lifetime.adb781e8.svg";